/**
 * HHGlobal Design System Spacing
 * A set of predefined spacing options based on increments of 4px to help make spacing decisions faster.
 * Spacing options can be applied in Figma using variables.
 */

/**
 * Border Radius
 * Applied to elements to create rounded corners.
 */
export const borderRadius = {
  0: {
    value: 0,
    valuePx: '0px',
    description: 'No border radius - sharp corners',
  },
  1: {
    value: 4,
    valuePx: '4px',
    description: 'Small border radius',
  },
  2: {
    value: 8,
    valuePx: '8px',
    description: 'Medium border radius',
  },
  3: {
    value: 32,
    valuePx: '32px',
    description: 'Large border radius - pill shape',
  },
} as const;

/**
 * Spacing
 * Applied to margins, padding, and gaps between elements.
 */
export const spacing = {
  0: {
    value: 0,
    valuePx: '0px',
    description: 'No spacing',
  },
  1: {
    value: 4,
    valuePx: '4px',
    description: 'Extra small spacing',
  },
  2: {
    value: 8,
    valuePx: '8px',
    description: 'Small spacing',
  },
  3: {
    value: 12,
    valuePx: '12px',
    description: 'Small-medium spacing',
  },
  4: {
    value: 16,
    valuePx: '16px',
    description: 'Medium spacing',
  },
  5: {
    value: 20,
    valuePx: '20px',
    description: 'Medium-large spacing',
  },
  6: {
    value: 24,
    valuePx: '24px',
    description: 'Large spacing',
  },
  7: {
    value: 32,
    valuePx: '32px',
    description: 'Extra large spacing',
  },
  8: {
    value: 40,
    valuePx: '40px',
    description: '2x large spacing',
  },
  9: {
    value: 60,
    valuePx: '60px',
    description: '3x large spacing',
  },
  10: {
    value: 80,
    valuePx: '80px',
    description: '4x large spacing',
  },
} as const;

/**
 * Spacing configuration object
 */
export const spacingConfig = {
  borderRadius,
  spacing,
} as const;
